import { AfsServiceDetailVo } from '@/apis/afterSales/afterSales.interface';
import UKToast from '@/components/UKToast/index';
import PreviewResource from '@/components/previewResource';
import { ResourceTypeEnum } from '@/components/previewResource/index-type';
import VideoPay from '@/components/videoDom/icons/videoPay_top.svg';
import { useTranslation } from '@/i18n/client';
import { imageUtil } from '@/utils/imageUtil';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import style from './index.module.scss';
interface detailInfoProps {
  afsDetailInfo: AfsServiceDetailVo;
}
const RefundInformation = ({ afsDetailInfo }: detailInfoProps) => {
  const { t } = useTranslation();

  const { afsServiceId, videoUrl, videoImage, images, reasonName, questionDesc } =
    afsDetailInfo || {};
  const [isOpenReviewImage, setIsOpenReviewImage] = useState<boolean>(false);
  const [currentImageUrl, setCurrentImageUrl] = useState<string>('');
  const [urlList, setUrlList] = useState<any[]>([]); //预览视频和图片列表

  // 复制售后单号
  const copyHandler = () => {
    UKToast.show({
      content: t('order.orderDetail.common.copySuccessTips'), // 弹窗内容
      icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
      duration: 2000, // 不写的话默认3000
    });
  };

  useEffect(() => {
    let urlList = [];
    if (videoUrl) {
      urlList.push({
        type: ResourceTypeEnum.Video,
        url: videoUrl,
      });
    }
    if (images && images.length > 0) {
      images.map((item) => {
        urlList.push({
          type: ResourceTypeEnum.Image,
          url: item,
        });
      });
    }
    setUrlList(urlList);
  }, [videoUrl, images]);

  return (
    <div className={style.return_info_wrap}>
      <div className={style.return_info_item}>
        <div className={style.return_info_title}>{t('afterSales.refundInformation.returnId')}</div>
        <div>
          {afsServiceId}
          <CopyToClipboard text={afsServiceId} onCopy={() => copyHandler()}>
            <span className={style.copy_btn}>{t('order.orderDetail.common.copyText')}</span>
          </CopyToClipboard>
        </div>
      </div>
      <div className={style.return_reason_title}>
        {t('afterSales.refundInformation.returnReason')}
      </div>
      <div className={style.return_reason_contents}>
        <div className={style.return_reason_content_title}>{reasonName}</div>

        <div className={style.return_reason_content_text}>{questionDesc}</div>
        <div className={style.mediaZone}>
          {videoUrl && (
            <div style={{ width: '140px', height: '140px', position: 'relative' }}>
              {/* <VideoPlayer position="top" maskType="ordinary" title={newUserNickName} content={content} src={item.videoUrl ? item.videoUrl : ""} /> */}
              <video
                style={{
                  width: '140px',
                  height: '140px',
                  objectFit: 'cover',
                  cursor: 'pointer',
                }}
                src={videoUrl ? videoUrl : ''}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpenReviewImage(true);
                  setCurrentImageUrl(videoUrl);
                }}
              ></video>
              <VideoPay style={{ position: 'absolute', top: '10px', left: '10px' }} />
            </div>
          )}
          {images?.map((image, index) => (
            <div key={index}>
              <img
                key={index}
                src={imageUtil.concatImgUrlWithoutForceHttps(image, 140, 0, 100)}
                width={140}
                height={140}
                alt=''
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpenReviewImage(true);
                  setCurrentImageUrl(image);
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <PreviewResource
        open={isOpenReviewImage}
        defaultUrl={currentImageUrl}
        resourceList={urlList}
        closeHandler={() => setIsOpenReviewImage(false)}
      />
    </div>
  );
};
export default RefundInformation;
